<template>
  <span class="label label-despatch-badge"><i :class="['fas', despatchIcon, 'mr-1']"></i> {{type | formatLookupName(DespatchTypeLookup)}}</span>
</template>

<script>
import { DespatchTypes, DespatchTypeLookup } from '@/store/types'

// Note: Only really used for PurchaseOrders now
// Orders now use TaskType as despatch method
export default {
  name: 'LabelDespatchBadge',
  props: {
    type: String
  },
  created() {
    this.DespatchTypeLookup = DespatchTypeLookup
  },
  computed: {
    despatchIcon() {
      if(this.type == DespatchTypes.delivery)
        return 'fa-truck'
      else if(this.type == DespatchTypes.pickup)
        return 'fa-person-carry'
      return ''
    }
  }
}
</script>
